export const MIN_ACTIVE_ORDERS_SEARCH_LENGTH = 3

export const ACTIVE_ORDERS_SEARCH_DEBOUNCE_MS = 1500

export const toActiveOrdersSearchParam = (input: string): string | null => {
  const trimmed = input.trim()
  return trimmed.length >= MIN_ACTIVE_ORDERS_SEARCH_LENGTH ? trimmed : null
}

export const shouldShowKanbanSearchMinLengthHint = (input: string): boolean => {
  const trimmedLen = input.trim().length
  return trimmedLen > 0 && trimmedLen < MIN_ACTIVE_ORDERS_SEARCH_LENGTH
}

export const hasKanbanFiltersAppliedToQuery = (
  isSellerKanbanFilterEnabled: boolean,
  debouncedSearchInput: string,
  kanbanFilterDeliveryType: number | null
): boolean =>
  isSellerKanbanFilterEnabled &&
  (toActiveOrdersSearchParam(debouncedSearchInput) !== null ||
    kanbanFilterDeliveryType !== null)

export const resolveKanbanDeliveryTypeAfterChipClick = (
  currentFilter: number | null,
  chipApiValue: number | null
): number | null => {
  if (chipApiValue === null) {
    return null
  }
  if (currentFilter === chipApiValue) {
    return null
  }
  return chipApiValue
}
